function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "btn_history_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h10v20H0z",
  "data-name": "Rectangle 949",
  style: {
    stroke: "#222",
    fill: "#fff"
  },
  transform: "translate(340 510)"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  "data-name": "bg_000_7%",
  rx: 20,
  style: {
    opacity: 0.07
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  rx: 19,
  style: {
    fill: "#fff"
  },
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  style: {
    fill: "transparent"
  },
  transform: "translate(8 8)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 77",
  style: {
    clipPath: "url(#btn_history_svg__a)"
  },
  transform: "translate(-319.373 -500)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 17",
  style: {
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "translate(330 510)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.35,
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 78",
  style: {
    clipPath: "url(#btn_history_svg__a)"
  },
  transform: "rotate(90 430.313 110.314)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 18",
  style: {
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "translate(330 510)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.35,
  style: {
    fill: "none"
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "m2807.149 645.535 2.622-2.622 2.622 2.622",
  "data-name": "Path 460",
  style: {
    strokeLinejoin: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "rotate(-18.01 -557.879 9166.97)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2807.959 629.669h1.184",
  "data-name": "Path 464",
  style: {
    strokeLinecap: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "translate(-2788.332 -619.02)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2809 633.4v5.46l2.968 2.968",
  "data-name": "Path 465",
  style: {
    strokeLinejoin: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "translate(-2788.373 -618.602)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 1 .8-1",
  "data-name": "Line 4",
  style: {
    strokeLinecap: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "rotate(28 -13.195 38.465)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 1 .8-1",
  "data-name": "Line 5",
  style: {
    strokeLinecap: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "rotate(4.01 -180.33 194.488)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 1 .8-1",
  "data-name": "Line 6",
  style: {
    strokeLinecap: "round",
    strokeWidth: "1.3px",
    fill: "none",
    stroke: "#222"
  },
  transform: "rotate(-18.01 57.824 -26.953)"
}));
export default SvgBtnHistory;